// DOMAINS
export const API = "/api";

// SERVICE
export const SERVICE = "/crops-svc";

// VERSIONS
export const V4 = "/v4";

// ENTITY
export const CROPS = "/crops";
